// Factory, not a plain object literal - see vuejs-sitegate's identical fix
// for why: registerModule()'d into the shared SSR store every request, but
// only evaluated once under a reused SSR context.
export default () => ({
  settings: {},
  defaultSettings: {
    enabled: false,
    message: 'This site uses cookies.',
    barSize: 'full-width', // small || full-width
    horizontalPosition: 'left', // left || right
    buttonText: 'Accept',
    preview: false
  }
})
